/** Control registration: the parser. */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseControl } from './parser';
const controlRegistration = {
    typeName: 'Control',
    parser: parseControl,
};
nodeRegistry.register(controlRegistration);
export * from './parser';
export * from './types';
//# sourceMappingURL=index.js.map